import React from 'react';
import ABBLogo from '../../assets/images/ABBLogo.svg';
import spinner from '../../assets/images/spinner.gif';
// import icons from '../../data/icons';
import './LoadScreen.css';

const LoadScreen = () =>
  (
    <section className={'loadScreen'}>
      <img className={'loadScreen__abb'} src={ABBLogo} alt={'abb logo'} />
      <section className={'loadScreen__mainArea'}>
        <img className={'loadScreen__spinner'} src={spinner} alt={'spinner gif'} />
        <h1 className={'loadScreen__title'}>ABB Services &amp; Consulting</h1>
        <h3 className={'loadScreen__text'}>App is loading, please wait...</h3>
      </section>
    </section>
  );

export default LoadScreen;



// WEBPACK FOOTER //
// ./src/components/LoadScreen/LoadScreen.js